import {gsap} from "gsap/all";
import $ from "jquery";

export class EarthLevel2 {

  constructor(el) {
    this.$el = $(el);
    this.init();
  }

  init() {
    gsap.set("#earth-level-2-part-1", {autoAlpha: 1});
    gsap.set("#earth-level-2-part-2", {autoAlpha: 0});
  }

  bringInitialEarth(callback) {
    const tl = gsap.timeline();

    gsap.set("#earth-level-2-part-1", {autoAlpha: 1});
    gsap.set("#earth-level-2-part-2", {autoAlpha: 0});

    tl.to($("#earth-level-2-part-1"), {
      autoAlpha: 1,
      duration: 0.45,
    });

    tl.fromTo($("#earth-level-2"), {scale: 0.8, autoAlpha: 0}, {autoAlpha: 1, scale: 1});

    tl.fromTo($("#screen-3-LEVEL2 .dropzones"), {scale: 0.8, autoAlpha: 0}, {autoAlpha: 1, scale: 1});

    tl.add(callback)
  }

  addWaterToEarth() {
    return new Promise((resolve) => {
      const tl = gsap.timeline();
      tl.set("#earth-level-2-part-1", {autoAlpha: 1});
      tl.set("#earth-level-2-part-2", {autoAlpha: 0});
      tl.add(() => {
        const lottie = $("#earth-level-2-part-1").data('lottie');
        lottie.setFrame(0);
        lottie.removeEventListener('complete');
        lottie.addEventListener('complete', () => {
          resolve();
        });
        lottie.play();
      }, 0.55)
    });
  }

  developEarthWithWater() {
    return new Promise((resolve) => {
      const tl = gsap.timeline();
      tl.set("#earth-level-2-part-1", {autoAlpha: 0});
      tl.set("#earth-level-2-part-2", {autoAlpha: 1});
      tl.add(() => {
        const lottie = $("#earth-level-2-part-2").data('lottie');
        lottie.setFrame(0);
        lottie.removeEventListener('complete');
        lottie.addEventListener('complete', () => {
          resolve();
        });
        lottie.play();
      }, 0.55)
    });
  }

  jumpToDevelopedState() {
    gsap.set("#earth-level-2", {autoAlpha: 1});
    gsap.set("#earth-level-2-part-1", {autoAlpha: 1});
    gsap.set("#earth-level-2-part-2", {autoAlpha: 1});
    const lottie = $("#earth-level-2-part-2").data('lottie');
    lottie.setFrame(149);
    lottie.pause();
  }

  hide() {
    const tl = gsap.timeline();
    ["#earth-level-2-part-1", "#earth-level-2-part-2"].forEach((el) => {
      const lottie = $("#earth-level-2").find(el).data('lottie');
      lottie.pause();
      tl.to(el, {
        autoAlpha: 0,
        duration: 0.45,
      }, 0)
    })
  }

  reset() {
    ["#earth-level-2-part-1", "#earth-level-2-part-2"].forEach((el) => {
      gsap.set(el, {autoAlpha: 0});
      const lottie = $("#earth-level-2").find(el).data('lottie');
      lottie.removeEventListener('complete');
      lottie.stateMachineStop();
      lottie.setFrame(0);
      lottie.stop();
    })
  }

}
